import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings-header',
  templateUrl: './settings-header.component.html',
  styleUrls: ['./settings-header.component.css']
})
export class SettingsHeaderComponent implements OnInit {

  userType = localStorage.getItem('type');
  isManager = localStorage.getItem('isManager');

  constructor() { }

  ngOnInit() {
  }

}
